import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const tabs = (
  reviewType: PerformanceReviewerStrategiesStrategyEnum[],
  filter: (strategy: PerformanceReviewerStrategiesStrategyEnum) => boolean = () => true
): { label: string; id: PerformanceReviewerStrategiesStrategyEnum }[] => {
  const availableTabs: { label: string; id: PerformanceReviewerStrategiesStrategyEnum }[] = []
  if (reviewType.includes('self') && filter('self')) {
    availableTabs.push({
      label: i18n.t('performance_process.reviews.review_type_questions_self_review'),
      id: 'self',
    })
  }

  if (reviewType.includes('manager') && filter('manager')) {
    availableTabs.push({
      label: i18n.t('performance_process.reviews.review_type_questions_manager'),
      id: 'manager',
    })
  }

  if (reviewType.includes('direct_reports') && filter('direct_reports')) {
    availableTabs.push({
      label: i18n.t('performance_process.reviews.review_type_questions_direct_report'),
      id: 'direct_reports',
    })
  }

  if (reviewType.includes('peers') && filter('peers')) {
    availableTabs.push({
      label: i18n.t('performance_process.reviews.review_type_questions_peer'),
      id: 'peers',
    })
  }

  return availableTabs
}

export default tabs
